import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { impersonateUser } from "../../actions/ImpersonateActions";
import { getUserByLogin, unlockUser } from "../../actions/UserActions";
import * as Constants from "../../utilities/Constants";
import { isEnterPressed } from "../../utilities/EventsHelper";

export class ImpersonationBySite extends Component {
    constructor (props) {
        super(props);

        this.state = {
            errorMessage: null,
            site: "",
            login: "",
            product: Constants.ORGANIZATION_PRODUCT_SENTRI7
        };

        this.handleImpersonateClick = this.handleImpersonateClick.bind(this);
        this.handleActivateAndLoginClick = this.handleActivateAndLoginClick.bind(this);
        this.onLoginChange = this.onLoginChange.bind(this);
        this.onSiteChange = this.onSiteChange.bind(this);
        this.onProductChange = this.onProductChange.bind(this);
    }

    handleEnterKey (e) {
        if (isEnterPressed(e)) {
            this.handleImpersonateClick();
        }
    }

    onSiteChange(event) {
        this.setState({ site: event.target.value });
    }

    onLoginChange(event) {
        this.setState({ login: event.target.value });
    }

    onProductChange (event) {
        this.setState({ product: event.target.value });
    }

    handleImpersonateClick () {
        this.props.impersonateByLoginUser(this.state.site, this.state.login, this.state.product);
    }

    handleActivateAndLoginClick () {
        this.props.unlockUserAndLogin(this.props.user.id, this.state.product);
    }

    render () {
        return (
            <div>
                <div className="inputGroup">
                    <div className="formControlTitle">Site</div>
                    <input id="txtSiteId" autoFocus={true} tabIndex="1"
                        onChange={this.onSiteChange}
                        value={this.state.site}
                        ref={(input) => { this.site = input; }}
                        className="picker-hollow" type="text"/>
                </div>

                <div className="inputGroup">

                    <div className="formControlTitle">User</div>
                    <input id="txtUserId" tabIndex="2"
                        onChange={this.onLoginChange}
                        value={this.state.login}
                        className="picker-hollow"
                        type="text"/>
                </div>
                <div className="inputGroup">
                    <div className="formControlTitle">Product</div>

                    <select id="ddlProduct" tabIndex="3" style={{ width: "160px" }}
                        className="picker-hollow"
                        onChange={this.onProductChange}>
                        <option value={Constants.ORGANIZATION_PRODUCT_SENTRI7}>{Constants.ORGANIZATION_PRODUCT_SENTRI7}</option>
                        <option value={Constants.ORGANIZATION_PRODUCT_QUANTIFI}>{Constants.ORGANIZATION_PRODUCT_QUANTIFI}</option>
                        <option value="Veriform">Veriform</option>
                        <option value={Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION}>{Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION}</option>
                    </select>
                </div>
                <div id="buttonContainer">
                    <button className="btn btn-primary" id="impersonateButton" tabIndex="5"
                        onClick={this.handleImpersonateClick}>
                        Login
                    </button>
                </div>

                {this.props.errorMessage && <div id="errorMessageContainer" className="alert alert-danger" role="alert"
                    style={{ display: "block" }}>
                    <b>Login Failed</b>&nbsp;{this.props.errorMessage}
                </div>
                }

                <div id="showLockMessageContainer" className="alert alert-danger" role="alert"
                    style={{ display: this.props.showLockMessage && this.props.user.id != null ? "block" : "none" }}>
                    This user's account is locked.
                    <button className="btn btn-primary" id="activateAndLogin"
                        onClick={this.handleActivateAndLoginClick}>Unlock & Login?
                    </button>
                </div>
            </div>
        );
    }
}

ImpersonationBySite.propTypes = {
    errorMessage: PropTypes.string
};

const mapStateToProps = state => ({
    errorMessage: state.impersonateState.errorMessage,
    showLockMessage: state.impersonateState.isUserLocked,
    user: state.impersonateState.user
});

const mapDispatchToProps = (dispatch) => {
    return ({
        impersonateByLoginUser: (site, userLogin, productName) => dispatch(getUserByLogin(site, userLogin)).then((user) => {
            if (!user.IsLocked) {
                dispatch(impersonateUser(user.Id, productName));
            }
        }),
        unlockUserAndLogin: (userId, productName) => dispatch(unlockUser(userId)).then(() => {
            dispatch(impersonateUser(userId, productName));
        })
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ImpersonationBySite);
